import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import withMatch from '@/hocs/withMatch';
import { colorPalette } from '../../../styles/styleGuide';
import { updateMobileMenuState } from '../../../redux/menu';
import Header, { whichLayout } from '../../Header';
import Footer from '../../Footer';
import MobileMenu from '../../MobileMenu';
import MobileLoginBar from '../../MobileLoginBar';
import Modal from '../../Modal';
import Head from '../meta/Head';
import ErrorBar from '../ui/ErrorBar';
import CMSPreviewMessage from '../ui/CMSPreviewMessage';
import CookieNotice from '../../CookieNotice';
import get from 'lodash.get';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    mobileMenuIsOpen: get(state, 'menu.mobileMenuIsOpen'),
    redirect: get(state, 'redirect')
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onPressMenuClose: function onPressMenuClose() {
      return dispatch(updateMobileMenuState(false));
    }
  };
};
var LayoutBase = /*#__PURE__*/function (_React$PureComponent) {
  function LayoutBase(props) {
    var _this;
    _classCallCheck(this, LayoutBase);
    _this = _callSuper(this, LayoutBase, [props]);
    _defineProperty(_this, "mainScrollView", null);
    _this.state = {};
    return _this;
  }
  _inherits(LayoutBase, _React$PureComponent);
  return _createClass(LayoutBase, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      var _this$props = this.props,
        settings = _this$props.settings,
        redirect = _this$props.redirect;
      var oldSettings = oldProps.settings;
      var previousPathname = this.state.previousPathname;

      // We need to scroll the page back to the top when we log in and land on the dashboard from the open env.
      // Both pages exist on /:projectSlug/closed, so we need something other than route params to determine
      // whether or not we landed on the dashboard as a result of logging in or merely navigating.
      if ((oldSettings && oldSettings.phase) !== (settings && settings.phase) && !redirect.params) {
        if (this.mainScrollView) {
          this.mainScrollView.scrollTop = 0;
          window.scrollTo(0, 0); // need this for iOS 10
        }
      }
      if (previousPathname !== window.location.pathname) {
        if (this.mainScrollView) {
          this.mainScrollView.scrollTop = 0;
          window.scrollTo(0, 0); // need this for iOS 10
        }
        this.setState({
          previousPathname: window.location.pathname
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        loggedIn = _this$props2.loggedIn,
        settings = _this$props2.settings,
        mobileMenuIsOpen = _this$props2.mobileMenuIsOpen,
        renderWidth = _this$props2.renderWidth,
        onPressMenuClose = _this$props2.onPressMenuClose,
        match = _this$props2.match,
        children = _this$props2.children,
        layoutSettings = _this$props2.layoutSettings,
        title = _this$props2.title,
        meta = _this$props2.meta;
      var layout = whichLayout(renderWidth);
      var isMobileMenuIsOpen = mobileMenuIsOpen && layout === 'small';
      var isLoggedIn = !!(settings && settings.user);
      return __jsx("div", {
        "data-id": "layout_LayoutBase_div"
      }, layout === 'small' ? __jsx(MobileMenuView, {
        color: loggedIn ? colorPalette.beige : colorPalette.lightBeige,
        "data-id": "layout_LayoutBase_MobileMenuView"
      }, __jsx(MobileLoginBar, {
        settings: settings,
        "data-id": "layout_LayoutBase_MobileLoginBar"
      }), __jsx(MobileMenu, {
        menuItems: settings && settings.menu,
        loggedIn: loggedIn,
        "data-id": "layout_LayoutBase_MobileMenu"
      })) : __jsx("div", {
        "data-id": "layout_LayoutBase_div"
      }), __jsx(MainView, {
        mobileMenuIsOpen: isMobileMenuIsOpen,
        onClick: function onClick() {
          if (isMobileMenuIsOpen) {
            onPressMenuClose();
          }
        },
        "data-id": "layout_LayoutBase_MainView"
      }, __jsx(Header, {
        renderWidth: renderWidth,
        settings: settings,
        hasMenu: layoutSettings.hasMenu,
        "data-id": "layout_LayoutBase_Header"
      }), __jsx(ContentView, {
        ref: function ref(el) {
          _this2.mainScrollView = el;
        },
        isClosedEnvOrPortal: match.params.env === 'closed' || match.params.projectSlug === 'portal',
        className: "scrollable",
        "data-id": "layout_LayoutBase_ContentView"
      }, children, settings && layoutSettings && layoutSettings.hasFooter && __jsx(Footer, {
        footer: settings && settings.footer,
        siteName: settings.siteName,
        "data-id": "layout_LayoutBase_Footer"
      }))), title && __jsx(Head, _extends({
        title: title
      }, meta, {
        "data-id": "layout_LayoutBase_Head"
      })), __jsx(Modal, {
        renderWidth: renderWidth,
        "data-id": "layout_LayoutBase_Modal"
      }), __jsx(ErrorBar, {
        settings: settings,
        "data-id": "layout_LayoutBase_ErrorBar"
      }), __jsx(CMSPreviewMessage, {
        "data-id": "layout_LayoutBase_CMSPreviewMessage"
      }), __jsx(CookieNotice, {
        loggedIn: isLoggedIn,
        renderWidth: renderWidth,
        "data-id": "layout_LayoutBase_CookieNotice"
      }));
    }
  }]);
}(React.PureComponent);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(LayoutBase));
var MainView = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100vw;\n  height: 100vh;\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  box-shadow: 0 2rem 10rem 0 rgba(0, 0, 0, 0.5);\n  transform: ", ";\n  transition: transform 0.22s;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n"])), function (props) {
  return props.mobileMenuIsOpen ? 'translate3d(-280rem, 0, 0)' : 'none';
});
var MobileMenuView = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 320rem;\n  height: 100vh;\n  overflow: auto;\n  -webkit-transform: translate3d(0, 0, 0);\n  -webkit-overflow-scrolling: touch;\n  position: absolute;\n  right: 0;\n  top: 0;\n  background: ", ";\n"])), colorPalette.beige);
var ContentView = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  overflow: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  background-color: ", ";\n  position: relative;\n"])), function (props) {
  return props.isClosedEnvOrPortal ? colorPalette.background : 'white';
});